module.exports = __webpack_public_path__ + "assets/img/logo-frame-tablet.e2c22a43.png";